import { render, staticRenderFns } from "./index.vue?vue&type=template&id=13dcf430&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=13dcf430&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dcf430",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/fe/mewo-website-vue-kr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13dcf430')) {
      api.createRecord('13dcf430', component.options)
    } else {
      api.reload('13dcf430', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=13dcf430&scoped=true", function () {
      api.rerender('13dcf430', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/support/index.vue"
export default component.exports